import { useCallback, useEffect, useRef, useState } from "react";
import { CommunicationService, MessageVM, TenantService, } from "@propertelligent/client-api";
import ChatBox from "./ChatBox";
import EmptyData from "../../common/EmptyData";
import { GetImages } from "../../../utils/GetImages";
import { UserLoginData } from "../../common/charts/Enums";
import { formatChatDate } from "../../../utils/DateHelper";
import SimpleSpinner from "../../loader";
import ChatListingTopHeader from "../../../newComponents/listings/top-listing-headers/chat-listing-top-header";
import UtilHelper from "../../../utils/UtilHelper";
import { Background } from "../../GlobalCss/Background";
import { TextCss } from "../../GlobalCss/TextCss";
import { Colors } from "../../GlobalCss/Colors";
import NameAvatarComponent from "../../../newComponents/NameAvatar/NameAvatar";
import { usePermissions } from "../../../hooks/usePermissions";

const ChatView = () => {
  const [searchValues, setSearchValues] = useState("");
  const [entityId, setEntityId] = useState();
  const [entityTypeId, setEntityTypeId] = useState();
  const [chatname, setChatName] = useState("");
  const [showSection, setShowSection] = useState("");
  const [messageChannel, setMessageChannel] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState<String>("All Messages");
  const [showMessage, setShowMessage] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [tenantList, settenantList] = useState([]);
  const [count, setCount] = useState<number>()
  const inputRef = useRef(null)

  const [messageData, setmessageData] = useState<MessageVM>({
    messageData: "",
    entityTypeId: entityTypeId,
    entityId: entityId,
  });

  const { canWrite } = usePermissions();
  const hasWritePermission = canWrite("Message");

  let api = selectedOption == "All Messages" ? CommunicationService.getApiMessageOrganizationlistMessagechannels :
    CommunicationService.getApiMessageOrganizationlistMessagechannelsUnread
  const fetchMessageChannel = useCallback((fromClick = false) => {
    setLoading(true);
    const
      searchQuery =
        typeof searchValues === "string" ? searchValues.toLowerCase() : "";

    api(
      parseInt(sessionStorage.getItem(UserLoginData.organization_id)),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      `(usr.FirstName + " " + usr.LastName).ToLower().Contains("${searchValues.toLowerCase().trim()}")`
    ).then((res) => {
      setCount(res?.recordCount)
      setMessageChannel(res?.success);
      setLoading(false);
    })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, [selectedOption, showSection, searchValues]);

  useEffect(() => {
    fetchMessageChannel();
  }, [searchValues, selectedOption]);

  const fetchList = () => {
    TenantService.getApiTenantOrganizationlookup(
      parseInt(sessionStorage.getItem(UserLoginData.organization_id)),
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      `(User.FirstName + " " + User.LastName).ToLower().Contains("${inputValue.toLowerCase().trim()}")`
    ).then((res) => {
      settenantList(res.success);
    }).catch((error) => { });
  };

  useEffect(() => {
    fetchList();
  }, [inputValue]);

  const fullName = sessionStorage.getItem(UserLoginData.user_name) || "";
  const nameParts = fullName.split(/\s+/).filter(Boolean);

  const firstName = nameParts[0] || "";
  const lastName = nameParts[1] || "";

  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };
  const handleSelectChange = useCallback((value: String) => setSelectedOption(value), []);
  const handleClickChange = useCallback((item) => {
    setEntityId(item.entityId);
    setEntityTypeId(item?.entityTypeId);
    setChatName(item?.name);
    setShowSection("chat");


    setMessageChannel((prev) =>
      prev.map((channel) =>
        channel.entityId === item.entityId
          ? { ...channel, unreadMessagesCount: 0 }
          : channel
      )
    );
  }, []);

  useEffect(() => {
    if (!loading && showSection === "") {
      if (messageChannel?.length > 0) {
        handleClickChange(messageChannel[0]);
      } else {
        setEntityId(null);
        setShowSection("selectChat");
      }
    }
  }, [loading, messageChannel, showSection, handleClickChange]);

  return (
    <>
      {loading && messageChannel?.length === 0 ? (
        <div className="d-flex justify-content-center align-items-center flex-grow-1 w-100" style={{ minHeight: "80vh" }}>
          <SimpleSpinner myClassName="Icon50" />
        </div>
      ) : (
        <div className="chatMainContainer">
          <ChatListingTopHeader
            PageHeading="Messages"
            ButtonName={hasWritePermission ? "New Message" : undefined}
            handleSort={() => { }}
            currentSortDirection={undefined}
            Count={count}
            handleSelectChange={handleSelectChange}
            searchTerm={searchValues}
            setSearchTerm={setSearchValues}
            filterOptions={undefined}
            setActiveTab={undefined}
            activeTab={undefined}
            aggregateValuesFilters={{
              "Unread Only": 0
            }}
            onClick={() => { setEntityId(null); setShowSection("selectChat"); handleClick() }}
          />
          <div className="chatSubContainer  ">
            <div className="chatLeftSection">
              {loading ? (
                <SimpleSpinner />
              ) : (
                <div className="chatItemContaner " >
                  {messageChannel?.length == 0 ? (
                    <EmptyData
                      mainText="No Message Found"
                      subText=""
                      button={undefined}
                      ImageSrc={GetImages.NewChat}
                    />
                  ) : (
                    messageChannel?.map((item, i) => {
                      const name = item?.name?.split(/\s+/).filter(Boolean);
                      return (
                        <div
                          className="chatItem "
                          style={{
                            background:
                              item.entityId === entityId
                                ? "var(--Selected-Bg)"
                                : "",
                          }}
                          key={i}
                          onClick={() => handleClickChange(item)} >
                          {/* <div className="userIcon">
                          <NameAvatarComponent
                            firstName={name[0]}
                            lastName={name[1]}
                            heightWidth={40}
                          />
                        </div> */}
                          <NameAvatarComponent
                            firstName={name[0]}
                            lastName={name[1]}
                            heightWidth={40}
                            shape="square"
                            className={TextCss.heading_700_16}
                            color={Colors.blue.regular}
                            backgroundColor={Colors.blue.lighter}
                          />

                          <div className="chatDetailsView">
                            <div className="flexBetweenAlignCenter">
                              <p className={TextCss.black.normal_text_700_14}> {item?.name} </p>
                              <p className="sub_text  grey_subtext1"> {formatChatDate(item?.lastMessageDateTime)} </p>
                            </div>
                            <div className="message_count sub_text d-flex flexBetweenAlignCenter">
                              <p className="sub_text  grey_subtext1" id="message-data" > {item?.lastMessageData} </p>
                              {item.unreadMessagesCount > 0 ? (
                                <div className="meesageCount">
                                  <p className="small_text white"> {item.unreadMessagesCount} </p>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>
              )}
            </div>
            {/* >>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> */}
            <div className="chatRightSection">

              {showSection == "" ? <div className="chatboxContainer">
                <EmptyData
                  ImageSrc={GetImages.EmptyEmail}
                  mainText={"Select An Item To Read"}
                  imgBackgroundClass={Background.LightBlue.Round.round80}
                /> </div> :
                <ChatBox
                  tenantId={undefined}
                  setShowMessage={setShowMessage}
                  entityId={entityId}
                  setEntityId={setEntityId}
                  entityTypeId={entityTypeId}
                  chatname={chatname}
                  setChatName={setChatName}
                  setEntityTypeId={setEntityTypeId}
                  fetchData={fetchMessageChannel}
                  messageData={messageData}
                  setmessageData={setmessageData}
                  tenantList={tenantList}
                  firstName={firstName}
                  lastName={lastName}
                  inputRef={inputRef}
                  hasWritePermission={hasWritePermission}
                  fetchList={fetchList} setShowSection={setShowSection} messageChannel={messageChannel} />}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ChatView;
